var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"text-box"},[_c('img',{staticClass:"display-img",attrs:{"src":require("../../../assets/heartbeatfamlogo.png"),"alt":"heartbeat"},on:{"click":_vm.handleHomeClick}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }